export default __webpack_public_path__ + "static/media/smoothie.87c6864a.jpg";